import axios from "axios";

// Production builds are served with the backend on the same origin (any published domain); dev uses the preview URL.
export const API = process.env.NODE_ENV === "production" ? "/api" : `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "tr_token";

export const api = axios.create({ baseURL: API });

let onUnauthorized = null;
export const setUnauthorizedHandler = (fn) => {
  onUnauthorized = fn;
};

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err.config?.url || "";
    if (err.response?.status === 401 && !url.includes("/auth/login")) onUnauthorized?.();
    return Promise.reject(err);
  }
);

export function errorMessage(err, fallback) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg).filter(Boolean).join(" ") || fallback;
  if (d && typeof d.message === "string") return d.message;
  return fallback;
}
